module.exports = __webpack_public_path__ + "static/media/healthio.6ff59fd2.jpeg";